import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
var _templateObject, _templateObject2, _templateObject3;
import { css } from "../../../lib/theming/Emotion";
export var rootTextareaSizeMixin = function rootTextareaSizeMixin(fontSize, lineHeight) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    font-size: ", ";\n    line-height: ", ";\n  "])), fontSize, lineHeight);
};
export var textareaSizeMixin = function textareaSizeMixin(paddingY, paddingX, minHeight) {
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    min-height: ", ";\n    padding: ", " ", ";\n  "])), minHeight, paddingY, paddingX);
};
export var counterSizeMixin = function counterSizeMixin(paddingX, paddingY) {
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n    right: ", ";\n    bottom: ", ";\n  "])), paddingY, paddingX);
};